import { memo } from 'react';
import styles from './AdvtFullSize.module.css';
import { iconsSources } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const AdvtFullSize = memo(({ advtInfo }) => {
  const colorChan = {
    sms: 'chan-sms',
    facebook: 'chan-facebook',
    vkgroup: 'chan-vkgroup', // сообщение вк
    telegram: 'chan-telegram',
    telegrambot: 'chan-telegrambot',
    viber: 'chan-viber',
    whatsapp: 'chan-whatsapp',
    livechat: 'chan-livechat',
    fbinstagram: 'chan-fbinstagram',
    vkcomments: 'chan-vkcomm', // повторение
    facebookcomments: 'chan-facebookcomments',
    smsMoney: 'chan-smsmoney',
    vk: 'chan-vkcomm', // комментарий вк
    vkcomm: 'chan-vkcomm', // комментарий вк
    ok: 'chan-ok',
    okgroup: 'chan-okgroup',
  };

  const colorBlockQR1 =
    advtInfo.qrTitle1 && colorChan[advtInfo.qrTitle1.toLowerCase()];
  const colorBlockQR2 =
    advtInfo.qrTitle2 && colorChan[advtInfo.qrTitle2.toLowerCase()];

  let phoneNumberFormat = formatPhoneNumber(advtInfo.number, '-');

  if (!advtInfo) return null;

  return (
    <div className={styles.wrapper}>
      {(advtInfo.qrCode1 || advtInfo.qrCode2) && (
        <div className={styles.qrWrapper}>
          {advtInfo.qrCode1 && (
            <div className={styles.qrBlock}>
              {advtInfo.qrTitle1 && (
                <span className={`${styles.qrTitle} ${styles[colorBlockQR1]}`}>
                  {advtInfo.qrTitle1}
                </span>
              )}
              <div className={styles.qrCode}>
                <img src={advtInfo.qrCode1} alt="qrCode1" />
              </div>
            </div>
          )}
          {advtInfo.qrCode2 && (
            <div className={styles.qrBlock}>
              {advtInfo.qrTitle2 && (
                <span className={`${styles.qrTitle} ${styles[colorBlockQR2]}`}>
                  {advtInfo.qrTitle2}
                </span>
              )}

              <div className={styles.qrCode}>
                <img src={advtInfo.qrCode2} alt="qrCode2" />
              </div>
            </div>
          )}
        </div>
      )}

      <div className={styles.info}>
        {advtInfo.label && <div className={styles.title}>{advtInfo.label}</div>}

        <div className={styles.numberAndSocial}>
          <div className={styles.socials}>
            {advtInfo.socials &&
              advtInfo.socials.map((item) => (
                <div key={item} className={styles.icon}>
                  <img src={iconsSources[item]} alt="social" />
                </div>
              ))}
          </div>
          {phoneNumberFormat && (
            <div className={styles.number}>{phoneNumberFormat}</div>
          )}
        </div>
      </div>
    </div>
  );
});

export default AdvtFullSize;
